const { ratio } = require('@hints/utils/math');

function getBmi(weightInKg, heightInM) {
    const weightRatio = Math.pow(heightInM, 2);
    return ratio(weightInKg, weightRatio);
}

module.exports = {
    getBmi
};